module.exports = __webpack_public_path__ + "static/WS_appflows_fisica_2-5bacae3b3ec9609a85e6b85383e5db69.gif";